import React, { useImperativeHandle, useState } from 'react'
import { useSelector } from 'react-redux'
import { SkillBiteEditSlice } from '../../../../../reducers'
import makeStyles from '@mui/styles/makeStyles'
import { Box, Button, Collapse, useTheme } from '@mui/material'
import { ControlPointRounded, HighlightOffRounded } from '@mui/icons-material'
import { CommitmentCheckIcon, CommitmentIcon, DraftJSIcon, TinyMceIcon } from '../icons'
import { PAGE_BLOCK_TYPES } from '../../utils/page-block-types'

const blockTypes = [
  {
    label: 'TinyMCE',
    value: PAGE_BLOCK_TYPES.TINYMCE,
    description: 'Culpa exercitation veniam et ad aute ea enim ut duis.',
    baseColor: '#6787F7',
    icon: <TinyMceIcon />
  },
  {
    label: 'DraftJs',
    value: PAGE_BLOCK_TYPES.DRAFTJS,
    description: 'Consectetur eu officia ad commodo mollit sit exercitation dolor Lorem.',
    baseColor: '#B27474',
    icon: <DraftJSIcon />
  },
  {
    label: 'Commitment',
    value: PAGE_BLOCK_TYPES.COMMITMENT,
    description: 'Lorem labore ex tempor ad do eiusmod deserunt.',
    baseColor: '#63AFED',
    icon: <CommitmentIcon />
  },
  {
    label: 'Commitment Check',
    value: PAGE_BLOCK_TYPES.COMMITMENT_CHECK,
    description: 'Veniam et laboris sit non exercitation culpa reprehenderit cillum velit sint eu.',
    baseColor: '#86B668',
    icon: <CommitmentCheckIcon />
  }
]

const useStyles = makeStyles(() => ({
  collapseContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    border: '1px dashed #BCBCBC',
    borderRadius: 10,
    width: '50%',
    margin: 'auto',
    marginTop: '16px'
  }
}))

const AddPageBlock = ({ onAddBlock }, ref) => {
  const classes = useStyles()
  const { palette } = useTheme()
  const selectedSession = useSelector(SkillBiteEditSlice.selectors.selectSelectedSession)
  const isFirstSession = selectedSession.order === 1

  const blockTypesWithColor = blockTypes.filter((contentType) => {
    // Removes Commitment Check Block if it's the First Session
    if (contentType.value === PAGE_BLOCK_TYPES.COMMITMENT_CHECK && isFirstSession) {
      return false
    }
    return true
  }).map((contentType) => {
    const color = palette.augmentColor({ color: { main: contentType.baseColor } })
    return {
      ...contentType,
      color
    }
  })

  useImperativeHandle(ref, () => ({
    collapse: () => setCollapsed(false)
  }))

  const [collapsed, setCollapsed] = useState(false)
  const handleAddBlockButtonClick = () => {
    setCollapsed(prev => !prev)
  }

  const ButtonIcon = collapsed ? HighlightOffRounded : ControlPointRounded
  const buttonLabel = collapsed ? 'Choose a block type' : 'Add Block'

  const handleBlockCreation = (event) => {
    const type = event.target.value
    onAddBlock(type)
  }

  return (
    <Box className={classes.collapseContainer}>
      <Button disableRipple size='large' data-test='add-block-btn' sx={{ width: '250px', color: palette.primary.main, ':hover': { background: 'transparent' } }} onClick={handleAddBlockButtonClick}>
        <ButtonIcon color='primary' sx={{ mr: 1 }} />
        {buttonLabel}
      </Button>
      <Collapse in={collapsed}>
        <Box display='flex' flexDirection='column' p={1}>
          {
            blockTypesWithColor.map((contentType) => (
              <Button
                key={contentType.value}
                value={contentType.value}
                fullWidth
                onClick={handleBlockCreation}
                sx={{
                  textTransform: 'none',
                  justifyContent: 'flex-start',
                  gap: 2,
                  ':hover': {
                    background: contentType.color.light,
                    color: '#FFF'
                  }
                }}
              >
                {contentType.icon}
                {contentType.label}
              </Button>
            ))
          }
        </Box>

      </Collapse>
    </Box>
  )
}

const AddPageBlockForwardRef = React.forwardRef(AddPageBlock)

export default AddPageBlockForwardRef
